import { render, staticRenderFns } from "./scene8.vue?vue&type=template&id=26e5b9b0&"
import script from "./scene8.vue?vue&type=script&lang=js&"
export * from "./scene8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports